import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { IFilterComponent, SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { FilterRecordService } from 'src/app/services/filter-record.service';
import { PrinterService } from '../../../services/printer.service';

@Component({
  selector: 'app-printer-filter',
  templateUrl: './printer-filter.component.html',
  styleUrls: ['./printer-filter.component.css']
})
export class PrinterFilterComponent  implements IFilterComponent, OnInit {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;

  constructor(private formBuilder: FormBuilder
    , private printerService: PrinterService
    , private filterRecordService: FilterRecordService) {

    this.form = this.formBuilder.group({
      Name: [''],
    });
  }

  get f() { return this.form.controls; }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('PrinterFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('PrinterFilterComponent', this.form);
  }

  async search(): Promise<any> {
    return await this.printerService.getPrinters(this.form.controls.Name.value);
  }

  async ngOnInit() {

  }
}
